import script from "./ProofOfDelivery.vue?vue&type=script&setup=true&lang=js"
export * from "./ProofOfDelivery.vue?vue&type=script&setup=true&lang=js"

import "./ProofOfDelivery.vue?vue&type=style&index=0&id=29d2aeef&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/ringg_deliveryhub-app_production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d2aeef"]])

export default __exports__